import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {createRequestOption} from '../../shared/util/request-util';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private http: HttpClient) {
  }

  public query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(`${environment.apiUrl}/sys-notifications`, {
      params: options,
      observe: 'response'
    });
  }

  public queryReportLog(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(`${environment.apiUrl}/sys-notifications-search`, {
      params: options,
      observe: 'response'
    });
  }

  public delete(data: any) {
    return this.http.post(`${environment.apiUrl}/sys-notification-statuses/delete`, data);
  }

  public check(body?: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/sys-notification-statuses`, body, {
      observe: 'response'
    })
  }
}
